var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.758C2 5.786 2.79 5 3.763 5c.975 0 1.765.786 1.764 1.758v17.65a1.76 1.76 0 0 1-1.764 1.758A1.76 1.76 0 0 1 2 24.409V6.758zm24.473 0c0-.97.789-1.758 1.764-1.758.975 0 1.765.786 1.763 1.758v17.65a1.76 1.76 0 0 1-1.763 1.758 1.76 1.76 0 0 1-1.764-1.758V6.758zm-14.551 1.91a1.76 1.76 0 0 0-1.764 1.759V20.74c0 .972.79 1.758 1.764 1.758a1.76 1.76 0 0 0 1.763-1.758V10.427a1.76 1.76 0 0 0-1.763-1.758zm6.395 4.72c0-.97.788-1.759 1.763-1.759.973 0 1.763.787 1.763 1.757v4.351c0 .97-.79 1.758-1.763 1.758a1.76 1.76 0 0 1-1.763-1.758v-4.35z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtl);
export default __webpack_public_path__ + "static/media/MTL.0623460a95e25836556e3ea085f02787.svg";
export { ForwardRef as ReactComponent };